// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__orX9F","sponsorImage":"card_sponsorImage__hNaTm"};